import axios from "axios";

import * as actionTypes from "./actionTypes";

export const initGetUserProfile = () => {
    return {
        type: actionTypes.INIT_GET_USER_PROFILE,
        userProfileLoading: true
    }
};

export const successGetUserProfile = (data) => {
    return {
        type: actionTypes.SUCCESS_GET_USER_PROFILE,
        userProfileLoading: false,
        userProfile: data.data
    }
};

export const failGetUserProfile = (error) => {
    return {
        type: actionTypes.FAIL_GET_USER_PROFILE,
        userProfileLoading: false,
        error: error
    }
};


export const getUserProfile = (bearerToken) => {
    const config = {
        headers: {
            Authorization: "Bearer " + bearerToken
        }
    }
    return dispatch => {
        dispatch(initGetUserProfile())
        axios.get('users/me', config).then(response => {
            dispatch(successGetUserProfile(response.data));
        })
            .catch(error => {
                dispatch(failGetUserProfile(error.message));
            })
    }
}

// ########################### EDIT USER PROFILE ###################:

export const initEditUser = () => {
    return {
        type: actionTypes.INIT_Edit_USER_PROFILE,
        userProfileLoading: true
    }
};

export const successEditUser = (data) => {
    return {
        type: actionTypes.INIT_Edit_USER_PROFILE,
        userProfileLoading: false,
        userProfile: data.data
    }
};

export const failEditUser = (error) => {
    return {
        type: actionTypes.INIT_Edit_USER_PROFILE,
        userProfileLoading: false,
        error: error
    }
};

export const editUserProfile = (bearerToken, name, userName, phone, profilePic) => {
    const config = {
        headers: {
            Authorization: "Bearer " + bearerToken
        }
    }
    const data = {};
    if (name) {
        data.name = name
    }
    if (userName) {
        data.username = userName
    }
    if (phone) {
        data.phone = phone
    }
    if (profilePic) {
        data.profile_picture = profilePic
    }
    return dispatch => {
        dispatch(initGetUserProfile())
        axios.put('users/me', data, config)
            .then(response => {
                dispatch(successGetUserProfile(response.data))
            })
            .catch(error=>{
                dispatch(failGetUserProfile(error.message))
            })
    }
}